var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
export class SuiAddressValidator {
    static validate(value) {
        return this.isHex(value) && this.getHexByteLength(value) === this.SUI_ADDRESS_LENGTH;
    }
    static isHex(value) {
        return /^(0x|0X)?[a-fA-F0-9]+$/.test(value) && value.length % 2 === 0;
    }
    static getHexByteLength(value) {
        return /^(0x|0X)/.test(value) ? (value.length - 2) / 2 : value.length / 2;
    }
}
SuiAddressValidator.SUI_ADDRESS_LENGTH = 32;
